import React from 'react'
import CheckBoxWhite from "../assets/CheckBoxWhite.svg"

function Pricing() {
  return (
    <div className="pricing-section" id='pricing'>
          <h3>Pricing</h3>
          <p>
            Simple, affordable and transparent pricing for all businesses.
          </p>
              <div className="pricing-card-group">
                <div className="pricing-card">
                  <h4>1.2%</h4>
                  <h5>Transaction Fee</h5>
                  <p>
                  No setup fees, monthly fees, or hidden fees
                  </p>
                    <div className="pricing-highlight-group">
                      <img src={CheckBoxWhite} alt="checkbox" />
                      <p>High Speed transactions</p>
                    </div>
                    <div className="pricing-highlight-group">
                      <img src={CheckBoxWhite} alt="checkbox" />
                      <p>No setup fees, monthly fees, or hidden fees</p>
                    </div>
                    <div className="pricing-highlight-group">
                      <img src={CheckBoxWhite} alt="checkbox" />
                      <p>Small charge of 1.2% on payments recieved</p>
                    </div>
                </div>
                <div className="pricing-card">
                  <h4>0%</h4>
                  <h5>Withdrawal Fee</h5>
                  <p>
                  Free withdrawal, no charges
                  </p>
                    <div className="pricing-highlight-group">
                      <img src={CheckBoxWhite} alt="checkbox" />
                      <p>Recieve payment straight to your local bank account instantly</p>
                    </div>
                    <div className="pricing-highlight-group">
                      <img src={CheckBoxWhite} alt="checkbox" />
                      <p>No extra charges when making withdrawals</p>
                    </div>
                    <div className="pricing-highlight-group">
                      <img src={CheckBoxWhite} alt="checkbox" />
                      <p>Accept payments from anywhere in the world.</p>
                    </div>
                </div>
              </div>
        </div>
  )
}

export default Pricing